<template>
  <div class="news">
    <p class="newTitle" @click="$router.push({path:'/news'})">新闻资讯</p>
    <div class="newsType">
      <div class="lTitle" @click="$router.push({path:'/news'})">
        <span>NEWS</span>
      </div>
      <div class="rType hidden-xs-only">
        <ul>
          <li
            @click="getStyle(index,item)"
            v-for="(item,index) in types"
            :class="[activeIndex == index?'active':'']"
          >
            {{item.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <!-- <span
            v-if="index+1 != types.length">/</span>-->
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </li>
        </ul>
      </div>
      <div class="newsContent">
        <ul>
          <li
            v-for="(item,index) in news.slice(0,3)"
            @click="$router.push({path:'/newsDetail',query:{id:item.id,name}})"
          >
            <div class="DetailsTitle">{{item.name}}</div>
            <div class="newDate">
              <span
                class="date hidden-sm-and-up"
              >{{item.create_date_nian}}-{{item.create_date_tian}}</span>
              <span class="month hidden-xs-only">{{item.create_date_tian}}</span>
              <span class="year hidden-xs-only">{{item.create_date_nian}}</span>
            </div>
            <div class="newsDetail">
              <p>{{item.describe}}</p>
            </div>

            <div class="newsDetail shoWd">
              <p>{{item.describe}}</p>
            </div>
            <div class="newDate shoWd">
              <span
                class="date hidden-sm-and-up"
              >{{item.create_date_nian}}-{{item.create_date_tian}}</span>
              <span class="month hidden-xs-only">{{item.create_date_tian}}</span>
              <span class="year hidden-xs-only">{{item.create_date_nian}}</span>
            </div>
          </li>
        </ul>
        <div class="more">
          <button @click="$router.push({path:'/news'})">更多</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../assets/js/request.js";
import qs from "qs";
export default {
  data() {
    return {
      types: [
        {
          id: 1,
          name: "公司要闻",
        },
        {
          id: 2,
          name: "行业动态",
        },
      ],
      activeIndex: 0,
      news: [],
    };
  },
  created() {
    this.name = this.types[0].name;
    //数据
    this.getData(1);
  },
  methods: {
    getStyle(index, item) {
      this.activeIndex = index;
      this.name = item.name;
      this.getData(item.id);
    },
    getData(id) {
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/news_index",
          qs.stringify({
            type: id,
            limit: 3,
          }),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.news = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
  },
};
</script>

<style scoped="scoped">
.news {
  width: 100%;
  height: 700px;
  background: #f7f7f7;
  padding: 50px 220px;
}

.news .newTitle {
  height: 30px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 18px;
  cursor: pointer;
}

.newsType .lTitle {
  width: 10%;
  height: 40px;
  display: inline-block;
  line-height: 40px;
  cursor: pointer;
}

.lTitle span {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 18px;
  opacity: 0.5;
}

.newsType {
  margin-top: 20px;
}

.newsType .rType {
  display: inline-block;
  width: 89%;
  height: 40px;
  text-align: right;
  box-sizing: border-box;
}

.rType ul li {
  display: inline-block;
  line-height: 40px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #676767;
  cursor: pointer;
}

.active {
  color: #216bd1 !important;
}

.newsContent {
  border: 1px solid transparent;
  width: 100%;
  height: auto;
  clear: both;
  margin-top: 20px;
}

.newsContent ul li {
  width: 32%;
  height: 380px;
  box-sizing: border-box;
  /* display: inline-block; */
  float: left;
  margin-right: 1%;
  padding: 70px;
  cursor: pointer;
  transition: all 0.5s ease;
}

.newsContent ul li:hover {
  /* background-image: url(../../assets/images/home/hoverb.png);
		background-size: 100% 100%; */
  background-color: #216bd1;
  /* box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
		 */
}

.newsContent ul li:hover .newDate,
.newsContent ul li:hover .newsDetail {
  display: none;
}

.newsContent ul li:hover .shoWd {
  display: block;
}

.newsContent ul li:hover .DetailsTitle,
.newsContent ul li:hover .month,
.newsContent ul li:hover .year,
.newsContent ul li:hover .newsDetail p {
  color: #ffffff;
}

.shoWd {
  display: none;
}

.DetailsTitle {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 29px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.newDate {
  text-align: center;
  margin-top: 30px;
}

.newDate .month {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #a7a7a7;
  line-height: 29px;
}

.newDate .year {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #a6a6a6;
  line-height: 29px;
}

.newsDetail p {
  margin-top: 50px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  line-height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.more {
  width: 100%;
  height: auto;
  text-align: center;
}

.more button {
  width: 205px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #216bd1;
  border-radius: 5px;
  margin-top: 40px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #216bd1;
  line-height: 19px;
}

@media screen and (max-width: 750px) {
  .news .newTitle {
    height: 30px;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    line-height: 0.1rem;
    cursor: pointer;
    text-align: center;
    color: #216bd1;
    font-weight: bold;
  }

  .newsType .lTitle {
    width: 100%;
    height: 40px;
    display: inline-block;
    line-height: 40px;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
  }

  .lTitle span {
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    line-height: 18px;
    opacity: 0.5;
  }

  .newsType {
    margin-top: 20px;
  }

  .newsType .rType {
    display: inline-block;
    width: 89%;
    height: 40px;
    text-align: right;
    box-sizing: border-box;
    float: right;
  }

  .rType ul li {
    display: inline-block;
    line-height: 0.1rem;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #676767;
    cursor: pointer;
  }

  .newsContent {
    width: 100%;
    height: auto;
    margin-top: 0.1rem;
  }

  .newsContent ul li {
    width: 100%;
    height: 380px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 1%;
    padding: 70px;
    cursor: pointer;
    transition: all 0.5s ease;
    border-bottom: 1px solid #727272;
  }

  .DetailsTitle {
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 0.2rem;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .newDate {
    text-align: left;
    margin-top: 10px;
  }

  .newDate .month {
    font-size: 0.15rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #a7a7a7;
    line-height: 0.1rem;
  }

  .newDate .date {
    height: 18px;
    font-size: 0.18rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }

  .newDate .year {
    font-size: 0.16rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #a6a6a6;
    line-height: 0.2rem;
  }

  .newsDetail p {
    margin-top: 30px;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #808080;
    line-height: 0.25rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-align: left;
  }

  .more button {
    width: 2rem;
    height: 0.45rem;
    background: #ffffff;
    border: 1px solid #216bd1;
    border-radius: 5px;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #216bd1;
    line-height: 19px;
  }

  .news {
    clear: both;
    width: 100%;
    height: auto;
    background: #ffffff;
    padding: 70px 25px;
  }

  .newsContent ul li:hover {
    /* background-image: url(../../assets/images/home/hoverb.png);
			background-size: 100% 100%; */
    background-color: #ffffff;
    /* box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
			 */
  }

  .newsContent ul li:hover .DetailsTitle {
    color: #216bd1;
  }

  .newsContent ul li:hover .month,
  .newsContent ul li:hover .year,
  .newsContent ul li:hover .newsDetail p {
    color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/news.vue